import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { Button } from '../../../tornado/button/button.component';
import { t } from '../../../i18n';
import { getInitialStyle, defaultContext } from './forgotCodeHint.style';
import { HIDE_SIGNAL, HOME_SIGNAL } from './forgotCodeHint.constants';

export class ForgotCodeHint extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
        },
        BackButton: {
          type: Button,
          label: t('global.back'),
        },
        Content: {
          Title: {
            text: {
              text: t('parentalCode.forgottenCode'),
            },
          },
          Body: {
            text: {
              text: t('parentalCode.lost.instruction'),
            },
          },
          HomeButton: {
            type: Button,
            label: t('parentalCode.lost.catalogReturn'),
          },
        },
      },
      getInitialStyle(),
      {},
    );
  }

  static _states() {
    return [
      class BackButton extends this {
        _getFocused() {
          return this.tag('BackButton');
        }

        _handleDown() {
          this._setState('HomeButton');

          return true;
        }

        _handleEnter() {
          this.signal(HIDE_SIGNAL);

          return true;
        }
      },
      class HomeButton extends this {
        _getFocused() {
          return this.tag('HomeButton');
        }

        _handleUp() {
          this._setState('BackButton');

          return true;
        }

        _handleEnter() {
          this.signal(HOME_SIGNAL);

          return true;
        }
      },
    ];
  }

  _init() {
    this._style = defaultContext;
    this.password = '';
    this._exceptionInterval = null;
  }

  _active() {
    this._setState('HomeButton');
  }

  _handleUp() {
    return true;
  }

  _handleDown() {
    return true;
  }
}
